import { render } from "./Sparkpost.vue?vue&type=template&id=34f40c25"
import script from "./Sparkpost.vue?vue&type=script&lang=js"
export * from "./Sparkpost.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__